export const RequestTypes = {
    RECORD_USER_AGREE: "RECORD_USER_AGREE",
    RECORD_QUESTIONS: "RECORD_QUESTIONS",
    RECORD_SESSION: "RECORD_SESSION"
};

export const SexTypes = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    NOT_SPECIFIED: "NOT_SPECIFIED"
};

const constants = {
    X_API_KEY: "S70mJbB9jN3AAGlvZhtpc1odJgDUwLaDONgRg0gc",
    UPDATE_SESSION: "UPDATE_SESSION",
    SET_CURRENT_QUESTION: "SET_CURRENT_QUESTION",
    SET_QUESTION_RESULT: "SET_QUESTION_RESULT",
    SET_RECORD_ID: "SET_RECORD_ID",
    SET_SHOW_TEST: "SET_SHOW_TEST",
    SET_SHOW_RESULTS: "SET_SHOW_RESULTS",
    RESET: "RESET",
    RESET_HARD: "RESET_HARD",
    REQUIRE_CONTACT: "REQUIRE_CONTACT",
    ADD_ERROR: "ADD_ERROR",
    CLEAR_ERROR: "CLEAR_ERROR",
    CLEAR_ALL_ERRORS: "CLEAR_ALL_ERRORS",
    USER_AGREE: "USER_AGREE",
    PROCESSING: "PROCESSING",
    SEX_TYPES: [SexTypes.MALE, SexTypes.FEMALE, SexTypes.NOT_SPECIFIED],
    SET_USER_AGE: "SET_USER_AGE",
    SET_USER_SEX: "SET_USER_SEX"
};

export default constants;